import React from "react";
import { Link } from "react-router-dom";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function CookieBanner() {
  const { hasResponded, acceptAll, rejectNonEssential, openPreferences } = useCookieConsent();

  if (hasResponded) return null;

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        This website uses cookies to enhance the user experience.{" "}
        <Link to="/privacy-policy" style={styles.link}>Read our Privacy Policy</Link>
      </p>
      <div style={styles.buttons}>
        <button style={styles.manageBtn} onClick={openPreferences}>
          Manage Preferences
        </button>
        <button style={styles.rejectBtn} onClick={rejectNonEssential}>
          Reject Non-Essential
        </button>
        <button style={styles.acceptBtn} onClick={acceptAll}>
          Accept All
        </button>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#2B373B",
    color: "#fff",
    fontSize: "14px",
    padding: "16px 24px",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    zIndex: 9999,
  },
  text: { margin: 0, flex: "1 1 260px" },
  link: { color: "#fff", textDecoration: "underline" },
  buttons: { display: "flex", gap: "8px", flexWrap: "wrap" },
  manageBtn: {
    background: "transparent",
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
  },
  rejectBtn: {
    background: "#C62828",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
  },
  acceptBtn: {
    background: "#2E7D32",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
  },
};